/**
 * @fileoverview POST handler for the "/engagement/landing_page_templates/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageTemplatesUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementLandingPageTemplatesUpdateArchivedStateProps,
  EngagementLandingPageTemplatesUpdateArchivedStateResult,
} from "./types";

export const postEngagementLandingPageTemplatesUpdateArchivedState = reactQueryMutationAdapter(
  engagementLandingPageTemplatesUpdateArchivedStateCacheKeys,
  ({
    appGroupId,
    ids,
    mark_as_archived,
  }: PostEngagementLandingPageTemplatesUpdateArchivedStateProps): Promise<EngagementLandingPageTemplatesUpdateArchivedStateResult> => {
    // manipulate props here as needed { ids, mark_as_archived }

    return fetch(
      "/engagement/landing_page_templates/update_archived_state",
      "POST",
      {
        app_group_id: appGroupId,
        ids,
        mark_as_archived,
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
